// カレントタブの表示切り替え
// newTargetに.is-currentを付与し直す
function toggleCurrentTab(targets, newTarget) {
  $(targets).removeClass('is-current');
  $(newTarget).addClass('is-current');
}

// パネル（スライダーおよびブロックのコンテナ）の表示切り替え
// 指定したcategoryを持つtargetに.is-activeを付与し直す
function toggleCurrentPanel(target, category) {
  $(target).removeClass('is-active');
  $(target + '[data-category-target=' + category + ']').addClass('is-active');
}

// タブ切り替え（ピックアップ/プランの共通スライダー）PC版
$('.js-switchTab').on('click', function () {
  var category = $(this).data('category');
  toggleCurrentTab('.js-switchTab', this);
  toggleCurrentPanel('.c-slider', category);
});

// タブ切り替え（ピックアップ/プランの共通スライダー）SP版
$('.js-switchTab-sp').change(function () {
  // 表示カテゴリの絞り込み
  var category = $(this).children('option:selected').data('category');
  toggleCurrentPanel('.c-slider', category);
});

// タブ切り替え（レストランページ・レストラン詳細ページのコンテナごと表示切り替え）PC版
$('.js-switchTab2').on('click', function () {
  var category = $(this).data('category');
  toggleCurrentTab('.js-switchTab2', this);
  toggleCurrentPanel('.target-container', category);
});

// タブ切り替え（レストランページ・レストラン詳細ページのコンテナごと表示切り替え）SP版
$('.js-switchTab2-sp').change(function () {
  var category = $(this).children('option:selected').data('category');
  toggleCurrentPanel('.target-container', category);
});

/*
 * =======================================================================
 */

// タブ切り替え（宿泊予約/レストラン予約フォーム）
$('.js-switchFormTab').on('click', function () {
  if (!$(this).hasClass('is-current')) {
    toggleCurrentTab('.js-switchFormTab', this);
    $('.category-container').toggleClass('is-active');
  }
});